import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { AsyncPipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MakeProvider } from '../../../../helpers/base-control-value-accessor';
import { ShIndeterminateDirective } from '../../../directives/indeterminate.directive';
import { FormValue } from '../../../entities/form-value.entity';
import { ShFormCheckboxComplexBaseComponent } from '../base-complex/form-checkbox-complex-base.component';

@Component({
    selector: 'sh-form-checkbox-base',
    templateUrl: '../base-complex/form-checkbox-complex-base.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MakeProvider(ShFormCheckboxBaseComponent)],
    standalone: true,
    imports: [ReactiveFormsModule, ShIndeterminateDirective, AsyncPipe]
})
export class ShFormCheckboxBaseComponent extends ShFormCheckboxComplexBaseComponent {
    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    propagateChange(fv: FormValue<boolean | null>): void {
        this.propagateSimpleChange(FormValue.unwrap(fv));
    }

    writeValue(obj: any): void {
        super.writeValue(FormValue.wrap(obj));
    }
}
